import useTranslation from '../../../hooks/useTranslation';

export const useConfigurationDateFilter = () => {
  const { t } = useTranslation();

  const configDateRangeFilter = {
    dateRangeLast4Week: {
      label: t('the last 4 weeks'),
      value: 'last4Week'
    },
    dateRangeMonth: {
      label: t('this month'),
      value: 'thisMonth'
    },
    dateRangeMonthAndPrevious: {
      label: t('this month and the previous'),
      value: 'thisMonthAndPrevious'
    },
    dateRangeLast3Month: {
      label: t('the last 3 months'),
      value: 'last3Months'
    },
    dateRangeLast6Month: {
      label: t('the last 6 months'),
      value: 'last6Months'
    },
    dateRangeCustom: {
      label: t('custom range'),
      value: 'customRange'
    }
  };

  return {
    configDateRangeFilter
  };
};
